module.exports = __webpack_public_path__ + "static/media/mental-health-active.7feafbf8.svg";